import { motion } from 'framer-motion';
import { LayoutGrid, MessageSquare, Zap } from 'lucide-react';

const features = [
  {
    icon: LayoutGrid,
    title: 'Visual Boards',
    description: 'Organize your projects with drag-and-drop boards, tasks, and due dates.',
    iconClass: 'icon-blue',
  },
  {
    icon: MessageSquare,
    title: 'Team Chat',
    description: 'Collaborate instantly in channels or DMs without leaving your workflow.',
    iconClass: 'icon-orange',
  },
  {
    icon: Zap,
    title: 'Unified Dashboard',
    description: 'View every update, message, and task in one place.',
    iconClass: 'icon-blue',
  },
];

export const Features = () => {
  return (
    <section id="features" className="py-20 bg-[#F8FAFC]" data-testid="features-section">
      <div className="container-main">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <span className="section-label section-label-blue">YOUR PRODUCTIVITY POWERHOUSE</span>
          <h2 className="text-3xl sm:text-4xl lg:text-[42px] font-bold text-[#1E293B] leading-tight mb-4">
            Meet BoardChat — The All-in-One<br />Collaboration Hub
          </h2>
          <p className="text-[#64748B] text-lg">
            Project management meets real-time communication. Finally.
          </p>
        </motion.div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="feature-card text-center"
              data-testid={`feature-card-${index}`}
            >
              <div className={`w-14 h-14 rounded-xl mx-auto mb-4 flex items-center justify-center ${feature.iconClass}`}>
                <feature.icon className="w-7 h-7" />
              </div>
              <h3 className="text-[#1E293B] font-semibold text-lg mb-2">
                {feature.title}
              </h3>
              <p className="text-[#64748B] text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Bottom tagline */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-center text-[#64748B] text-base"
        >
          No more tool-hopping. No more chaos.{' '}
          <span className="text-[#1E293B] font-semibold">Just teamwork that flows.</span>
        </motion.p>
      </div>
    </section>
  );
};
